module.exports = __webpack_public_path__ + "static/img/邱凯总经理.15ea4984.png";